/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { array, bool, string } from 'prop-types';
import { useDispatch } from 'react-redux';
import { setSelectedInlineAddons } from '../../../../../../../../state/ducks/App/App-Actions';

const useStyle = makeStyles((theme) => ({
    addonHeading: {
        color: '#000',
        fontFamily: 'museo-sans, "Area Variable"',
        fontSize: 'var(--fontSizes-fontHeader5DT, 20px)',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: 'var(--lineHeights-lineHeader5DT, 25px)',
        letterSpacing: '0.2px',
    },
    subHeaddingAddon: {
        color: 'var(--ENT-gray-700, #434343)',
        fontFamily: 'museo-sans, "Area Variable"',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '22px',
        letterSpacing: '0.14px',
        marginTop: '12px',
    },
}));

const PDPAddonMessage = ({
    pdpContent, isZipInVaild, isProductNotAvailable,
}) => {
    const classes = useStyle();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setSelectedInlineAddons([]));
    }, []);
    return (
        <div className={classes.addonContainer}>
            <div className={classes.addonHeading}>
                {pdpContent?.entries?.[0]?.add_on_heading_copy || 'Make your gift extra special'}
            </div>
            <div className={classes.subHeaddingAddon}>
                {
                    !isProductNotAvailable ? (
                        <>
                            {isZipInVaild
                                ? 'Enter a ZIP code to see available extras'
                                : 'Add-ons are not available in this ZIP code'}
                        </>
                    ) : 'Add-ons are not available in this ZIP code'
                }
            </div>
        </div>
    );
};
PDPAddonMessage.propTypes = {
    pdpContent: array.isRequired,
    isZipInVaild: bool,
    isProductNotAvailable: bool,
};
PDPAddonMessage.defaultProps = {
    isZipInVaild: false,
    isProductNotAvailable: false,
};
export default PDPAddonMessage;
